<template>
    <div class="d-flex flex-column mb-2">
        <label class="text-muted font-weight-bold">{{
            $t('nBox.form.variablesWeight')
        }}</label>
        <div class="d-flex flex-wrap">
            <div
                class="d-flex mb-2"
                :key="variable.id"
                v-for="(variable, i) in variables"
            >
                <div>
                    <b-form-input
                        class="input"
                        size="sm"
                        no-wheel
                        type="number"
                        :value="variable.result_weight"
                        :state="validations[i].result_weight.isValid"
                        @input="$emit('update', i, $event)"
                    />
                    <small class="text-muted">
                        {{
                            variable.module == 'values'
                                ? $t('values.evaluations')
                                : $t('targets.targets')
                        }}</small
                    >
                </div>
                <b-input-group-prepend is-text v-if="i !== variables.length - 1"
                    >+</b-input-group-prepend
                >
                <b-input-group-append
                    is-text
                    v-if="i == variables.length - 1"
                    >{{ '= ' + weightSum + '%' }}</b-input-group-append
                >
            </div>
        </div>
        <div>
            <b-form-invalid-feedback :state="showRequiredValidation">
                {{ $t('form.validations.required') }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
                :state="showSumOfVariablesWeightValidation"
            >
                {{ $t('nBox.form.validations.variablesWeight') }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback :state="showMinValueValidation">
                {{ $t('form.validations.minValue', { value: 0 }) }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback :state="showMaxValueValidation">
                {{ $t('form.validations.maxValue', { value: 100 }) }}
            </b-form-invalid-feedback>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        variables: {
            type: Array,
            required: true,
        },
        validations: {
            type: Array,
            required: true,
        },
    },
    computed: {
        showRequiredValidation() {
            return this.isValid('required')
        },
        showSumOfVariablesWeightValidation() {
            return this.isValid('sumOfVariablesWeight')
        },
        showMinValueValidation() {
            return this.isValid('minValue')
        },
        showMaxValueValidation() {
            return this.isValid('maxValue')
        },
        weightSum() {
            return this.variables.reduce((acc, item) => {
                if (item.result_weight) {
                    return acc + parseFloat(item.result_weight)
                }
                return acc
            }, 0)
        },
    },
    methods: {
        isValid(validation) {
            return this.validations.every(v => {
                return v.result_weight[validation] !== false
            })
        },
    },
}
</script>
<style lang="sass" scoped>
.input
    min-width: 60px
    max-width: 80px
</style>
